import { useCallback, useState } from 'react';

import { useHistory } from 'react-router-dom';

export const useSetter = (setter, newValue) => {
  return useCallback(() => {
    setter(newValue);
  }, [setter, newValue]);
};

export const useNavigateToStoreTab = (newValue) => {
  const history = useHistory();
  return useCallback(() => {
    history.push(`./${newValue}`);
  }, [history, newValue]);
};

export const useValidationErrors = () => {
  const [errors, setErrors] = useState([]);
  const updateErrors = useCallback(
    (field, hasError) => {
      setErrors((currentErrors) => {
        if (hasError) {
          if (currentErrors.includes(field)) {
            return currentErrors;
          }
          return [...currentErrors, field];
        }
        return [...currentErrors.filter((err) => err !== field)];
      });
    },
    [setErrors],
  );
  return { errors, updateErrors };
};
